import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFara = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={23} fill='currentColor' {...props}>
    <path
      fillRule='evenodd'
      d='M11.845 13.71c.447.761.979 1.692 1.426 2.453 2.029-4.977 3.285-4.929 4.674-6.161-1.763.024-4.59 1.1-6.1 3.708M8.523 19.774h1.438a1.91 1.91 0 0 0 1.909 1.897 1.91 1.91 0 0 0 1.908-1.897h1.413V23H8.523z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M11.87 20.91a1.16 1.16 0 1 0 0-2.32 1.16 1.16 0 0 0 0 2.32M20.132 14.834v-1.437a1.91 1.91 0 0 0 1.896-1.909 1.91 1.91 0 0 0-1.896-1.909V8.166h3.225v6.668z'
      clipRule='evenodd'
    />
    <path d='M20.108 12.648a1.16 1.16 0 1 0 0-2.32 1.16 1.16 0 0 0 0 2.32' />
    <path
      fillRule='evenodd'
      d='M8.523 3.225h1.438A1.91 1.91 0 0 1 11.87 1.33a1.91 1.91 0 0 1 1.908 1.896h1.413V0H8.523z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M11.87 4.41a1.16 1.16 0 1 0 0-2.32 1.16 1.16 0 0 0 0 2.32M3.583 14.834v-1.437a1.91 1.91 0 0 1-1.897-1.909 1.91 1.91 0 0 1 1.897-1.909V8.166H.357v6.668z'
      clipRule='evenodd'
    />
    <path d='M3.607 12.648a1.16 1.16 0 1 0 0-2.32 1.16 1.16 0 0 0 0 2.32' />
    <path
      fillRule='evenodd'
      d='m3.643 14.991 1.015 1.015A1.907 1.907 0 0 0 4.67 18.7c.737.737 1.933.737 2.694.012l1.002 1.002-2.283 2.271-4.71-4.71z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M6.856 16.525a1.174 1.174 0 0 1 0 1.643 1.174 1.174 0 0 1-1.642 0 1.174 1.174 0 0 1 0-1.643 1.15 1.15 0 0 1 1.642 0M15.348 19.714l1.015-1.014a1.906 1.906 0 0 0 2.694-.012c.737-.737.737-1.933.012-2.694l1.002-1.003 2.271 2.283-4.71 4.711z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M16.882 16.501a1.174 1.174 0 0 1 1.643 0 1.174 1.174 0 0 1 0 1.643 1.174 1.174 0 0 1-1.643 0 1.15 1.15 0 0 1 0-1.643M15.348 3.286 16.363 4.3a1.907 1.907 0 0 1 2.694.012c.737.737.737 1.933.012 2.694L20.07 8.01l2.271-2.283-4.71-4.711z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M16.882 6.499a1.174 1.174 0 0 0 1.643 0 1.174 1.174 0 0 0 0-1.643 1.174 1.174 0 0 0-1.643 0 1.15 1.15 0 0 0 0 1.643M3.643 8.009l1.015-1.015A1.907 1.907 0 0 1 4.67 4.3a1.93 1.93 0 0 1 2.694-.012l1.002-1.002-2.283-2.271-4.71 4.71z'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='M6.856 6.474a1.174 1.174 0 0 0 0-1.643 1.174 1.174 0 0 0-1.642 0 1.174 1.174 0 0 0 0 1.643 1.15 1.15 0 0 0 1.642 0M11.822 5.255c.422 0 .664.507.664.93s-.254 3.624-.665 3.624c-.41 0-.664-3.213-.664-3.624-.012-.41.242-.93.665-.93M13.947 5.545c.399.133.471.7.326 1.099-.133.399-1.413 3.346-1.812 3.213-.398-.133.411-3.25.544-3.648.145-.399.544-.797.942-.664M9.635 5.545c-.399.133-.471.7-.326 1.099.133.399 1.413 3.346 1.812 3.213.398-.133-.411-3.25-.544-3.648-.145-.399-.544-.797-.942-.664M15.989 6.62c.314.277.169.82-.109 1.135-.278.314-2.573 2.573-2.887 2.295-.302-.266 1.619-2.85 1.884-3.165.266-.314.798-.531 1.112-.266M17.415 8.407c.205.363-.11.834-.472 1.04-.362.205-3.273 1.582-3.479 1.22s2.453-2.175 2.815-2.38.93-.242 1.136.12M7.508 6.62c-.314.277-.169.82.11 1.135.277.314 2.572 2.573 2.886 2.295.314-.266-1.606-2.85-1.872-3.165-.278-.314-.797-.531-1.124-.266M6.095 8.407c-.205.363.11.834.472 1.04.362.205 3.273 1.582 3.479 1.22S7.593 8.491 7.23 8.286s-.93-.242-1.136.12M11.845 10.304c.725 0 1.33.495 1.498 1.172a7.8 7.8 0 0 0-1.51 1.51 7.4 7.4 0 0 0-1.498-1.51 1.57 1.57 0 0 1 1.51-1.172M11.846 14.254l1.256 2.126c0 .689-.568 1.256-1.256 1.256a1.263 1.263 0 0 1-1.257-1.256zM11.845 13.71c-.447.761-.978 1.692-1.425 2.453-2.03-4.977-3.286-4.929-4.675-6.161 1.752.024 4.578 1.1 6.1 3.708'
      clipRule='evenodd'
    />
  </svg>
);
export default SvgFara;
